import { toDisplayAge } from '../../packages/neb-input/nebFormatUtils';
import { parseDate } from '../../packages/neb-utils/date-util';
import { objToName } from '../../packages/neb-utils/formatters';

const formatDate = date => {
  if (!date) {
    return '-';
  }

  return parseDate(date).format('MM/DD/YYYY');
};

export const formatHeaderInfo = model => {
  const {
    patient,
    summaryLastUpdated,
    firstVisit,
    lastVisit,
    nextVisit,
    totalPastVisits,
    totalAppointments,
  } = model;

  return {
    patientName: objToName(patient),
    patientDob: formatDate(patient.dateOfBirth),
    patientAge: patient.dateOfBirth
      ? `(${toDisplayAge(patient.dateOfBirth)})`
      : '',
    summaryDate: summaryLastUpdated ? formatDate(summaryLastUpdated) : '-',
    firstVisit: formatDate(firstVisit),
    lastVisit: formatDate(lastVisit),
    nextVisit: formatDate(nextVisit),
    totalPastVisits,
    totalAppointments,
  };
};
